


















import jquery from "jquery";
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import Header from "@/components/layout/Header.vue";
import Footer from "@/components/layout/Footer.vue";
import ToastPresenter from "@/components/layout/ToastPresenter.vue";
import AppPageSpinner from "@/components/AppPageSpinner.vue";
import axios from "./api/axios";
import { AuthState, namespaceAuth, AuthActionTypes, AuthMutationTypes } from "./store/auth";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

if (process.env["NODE_ENV"] !== "development") {
  Sentry.init({
    dsn: process.env["VUE_APP_SENTRY_API_KEY"] || "https://1d436b822e06464e923bcb113cb3428c@sentry.iveitteam.hu:80/5",
    integrations: [new VueIntegration({ Vue, attachProps: true })]
  });
}

@Component({
  name: "App",
  data() {
    return {
      isLoading: true
    };
  },
  components: {
    Header,
    Footer,
    AppPageSpinner,
    ToastPresenter
  }
})
export default class App extends Vue {
  isLoading!: boolean;

  mounted() {
    this.initializeTemplateScripts();
    axios.setUnauthorizedCallback(() => {
      this.$store.dispatch(`${namespaceAuth}/${AuthActionTypes.Logout}`);
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    });
    if (axios.getToken()) {
      this.$store.dispatch(`${namespaceAuth}/${AuthActionTypes.GetUser}`);
    } else {
      // Commit SetUser for the guards that are subscribed to it.
      this.$store.commit(`${namespaceAuth}/${AuthMutationTypes.SetUser}`, null);
    }

    window.onload = () => (this.isLoading = false);
  }

  private initializeTemplateScripts(): void {
    (window as any).$ = jquery;

    const coreScript = document.createElement("script");
    coreScript.setAttribute("src", "/core.min.js");
    coreScript.onload = function() {
      const uiScript = document.createElement("script");
      uiScript.setAttribute("src", "/script.js");
      document.head.appendChild(uiScript);
    };
    document.head.appendChild(coreScript);
  }
}
